<template>
  <div class="car-info">
    <div style="padding: 0 10px">
      <piczoom :src="getSrc">
        <img style="width: 414px; height: 340px" :src="getSrc" />
      </piczoom>
    </div>
    <div>
      <ul class="u-myflex u-color-white u-flexwrap">
        <li class="u-w-50"><span>车牌号码：</span>{{ data.plateNo }}</li>
        <li class="u-w-50"><span>车牌颜色：</span>{{ data.plateColor }}</li>
        <li class="u-w-50"><span>车牌种类：</span>{{ data.plateClass }}</li>
        <li class="u-w-50"><span>车辆类型：</span>{{ data.vehicleClass }}</li>
        <li class="u-w-50"><span>车辆类别：</span>{{ data.vehicleType }}</li>
        <li class="u-w-50"><span>车辆品牌：</span>{{ data.vehicleBrand }}</li>
        <li class="u-w-100"><span>所属企业：</span>{{ data.carCompany }}</li>
        <li class="u-w-100"><span>所属部门：</span>{{ data.departmentName }}</li>
        <li class="u-w-100"><span>来访车辆类型：</span>{{ data.carFrom }}</li>
        <li class="u-w-100"><span>通行时间：</span>{{ data.passingTimeFormat }}</li>
        <li class="u-w-100"><span>设备地址：</span>{{ data.deviceName }}</li>
        <li class="u-w-100"><span>{{ data.deviceType == 2 ? '闸机地址' : '卡口地址' }}：</span>{{ data.tollgateName }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import piczoom from "@/components/piczoom.vue";

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    piczoom,
  },
  computed: {
    getSrc() {
      return this.data.storageUrl1 || this.data.imgsrc || "static/img/img_error3.png";
    },
  },
};
</script>

<style lang="scss">
.car-info {
  display: flex;
  ul {
    li {
      text-align: left;
      padding: 6px 0;
      color: #e1e1e1;
      span {
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
  > div {
    flex: 1;
    text-align: left;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cards-info/carInfor.vue